import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import GatsbyImage from 'gatsby-image';

function Hero() {
  const { heroImage } = useStaticQuery(
    graphql`
      {
        heroImage: file(relativePath: { eq: "hero.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 1920) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `
  );
  return (
    <header className="relative w-full mx-auto max-w-7xl">
      <div className="absolute inset-0 sm:relative sm:h-0 sm:aspect-ratio-16/9">
        <div className="absolute inset-0 flex bg-light-pink">
          <GatsbyImage
            fluid={heroImage.childImageSharp.fluid}
            className="flex-1"
          />
        </div>
      </div>
      <div className="relative flex items-center justify-center sm:absolute sm:inset-0">
        <div className="py-24 text-center text-white uppercase">
          <h2 className="text-3xl text-shadow">
            Don't miss out <br />
            <span className="text-5xl font-bold uppercase">
              Back by <br />
              popular demand
            </span>
          </h2>
          <Link to="/collections/jeans/" className="mt-2 button">
            Shop jeans now
          </Link>
        </div>
      </div>
    </header>
  );
}

export { Hero };
